import { Link } from "react-router-dom";
import { ArrowLeft, X } from "lucide-react";
import { PAYMENT } from "../constants/testIds";

export default function PaymentCancelPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 lg:px-16 py-24 text-center min-h-[60vh] flex flex-col items-center justify-center">
      <div className="w-20 h-20 rounded-full bg-[#FDF3ED] flex items-center justify-center mb-6">
        <X className="w-10 h-10 text-[#B85C56]" strokeWidth={1.5} />
      </div>
      <div className="eyebrow">Payment Cancelled</div>
      <h1 data-testid={PAYMENT.cancelHeading} className="font-serif text-4xl sm:text-5xl mt-4">
        No worries — your cart is saved
      </h1>
      <p className="text-[#6B5757] mt-6 max-w-lg leading-relaxed">
        Nothing was charged. When you're ready, come back and complete your checkout.
      </p>
      <Link to="/shop" className="btn-primary inline-flex items-center gap-3 mt-10">
        <ArrowLeft className="w-4 h-4" /> Return to Shop
      </Link>
    </div>
  );
}
